import { TimesheetProvider } from ".";
import {
  fetchTimesheetForReview,
  useTimesheetReview,
} from "../request-handler";

export const TimesheetReviewProvider = ({ children, filters, date }) => {
  return (
    <TimesheetProvider
      requestHandler={fetchTimesheetForReview}
      filters={filters}
      date={date}
    >
      {children}
    </TimesheetProvider>
  );
};
